/** Locale used for every figure on the dashboard, so grouping is stable across viewers. */
const LOCALE = 'en-US';

export function formatCount(value: number): string {
  return value.toLocaleString(LOCALE);
}

/** Percentages arrive pre-rounded from the server; this only adds the unit. */
export function formatPct(value: number): string {
  return `${value}%`;
}

export interface Change {
  arrow: '▲' | '▼' | '';
  text: string;
  /** Whether the metric fell — the chip then reads as a caution rather than a gain. */
  down: boolean;
}

/** A null change means the previous period was zero, where a ratio says nothing. */
export function formatChange(changePct: number | null): Change {
  if (changePct == null) {
    return { arrow: '', text: '—', down: false };
  }
  const arrow = changePct > 0 ? '▲' : changePct < 0 ? '▼' : '';
  return { arrow, text: formatPct(Math.abs(changePct)), down: changePct < 0 };
}

export function formatDate(iso?: string): string {
  if (!iso) {
    return '—';
  }
  const date = new Date(iso);
  return Number.isNaN(date.getTime()) ? '—' : date.toLocaleDateString(LOCALE);
}

/** Initials for an avatar chip, from a name or an email when there is no name yet. */
export function initialsOf(name: string, email: string): string {
  const source = name.trim() || email.split('@')[0] || '';
  const parts = source.split(/[\s._-]+/).filter(Boolean);
  if (parts.length === 0) {
    return '?';
  }
  return parts
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase() ?? '')
    .join('');
}
